module.exports = __webpack_public_path__ + "static/collage-672e209d11ab3bd0df656904ca942563.png";